import React, { useState, useEffect } from 'react';
import styles from './MeasureToolContainer.module.scss';
import { colors } from './AllColorList';
import { COLOR_HEX_LENGTH } from '../../constants/constants';

export const ColorPanel = ({allStyleSectionData, changeColorVal}) => {
  const [allColors, setAllColors] = useState([]);
  const [customColor, setCustomColor] = useState('#324b52');
  const [customColorText, setCustomColorText] = useState('#324b52');
  const [disableTextSelect, setDisableTextSelect] = useState(true);
  const [isTextActive, setIsTextActive] = useState(false);

  useEffect(() => {
    if ((customColorText?.length === COLOR_HEX_LENGTH) && isTextActive) {
      updateColor();
    }
  }, [customColorText])

  useEffect(() => {
    if (colors?.length) {
      let colorsCopy = JSON.parse(JSON.stringify(colors));
      let anySelected = false;
      for (let i = 0; i < colorsCopy.length; i++) {
        for (let j = 0; j < colorsCopy[i].subColors.length; j++) {
          if (colorsCopy[i].subColors[j].colorValue === allStyleSectionData?.lineColor) {
            colorsCopy[i].subColors[j]['selected'] = true;
            setDisableTextSelect(true);
            anySelected = true;
            break;
          }
        }
      }
      if (!anySelected) {
        setDisableTextSelect(false);
      }
      setAllColors(colorsCopy);
    }
  }, [colors, allStyleSectionData]);

  const changeValue = (e) => {
    let colorValue = e?.target?.value;
    colorValue = colorValue.trim();
    colorValue = colorValue.replace(/[^#0-9a-f]/gi, '')
    if (colorValue?.length <= COLOR_HEX_LENGTH) {
      if (customColorText.length === 0) {
        if (colorValue?.length === 1 || colorValue?.length === 6) {
          setCustomColorText('#' + colorValue);
        } else {
          setCustomColorText(colorValue);
        }
      } else {
        setCustomColorText(colorValue);
      }
    }
  };

  const updateColor = () => {
    changeColorVal(customColorText);
    setCustomColor(customColorText);
    setDisableTextSelect(false);
  }

  const resetValues = () => {
    changeColorVal('#FCEE31');
    setCustomColor('#324b52');
    setCustomColorText('#324b52')
    setDisableTextSelect(true);
  }
  
  const callBlurEvent = (e) => {
    if (customColorText?.length === 0) {
      resetValues();
    }
    setIsTextActive(false);
  }

  return (
    <div className={styles.colorPanelContainer}>
      {!!allColors?.length &&
        allColors.map((rowVal, ind) => {
          return (
            <div className={styles.colorPanelRow} key={ind}>
              {rowVal.subColors.map((colorVal, subInd) => {
                const styleObj = {
                  background: colorVal.colorValue,
                }
                return (
                  <div className={styles.cardParent} key={ind+''+subInd}>
                    <div
                      className={styles.colorPanelCard}
                      key={ind + '' + subInd}
                      style={styleObj}
                      onClick={() => changeColorVal(colorVal.colorValue)}></div>
                      {colorVal.selected && <div className={styles.cardActive}></div>}
                      {!colorVal.selected && <div className={styles.cardUnActive}></div>}
                  </div>
                );
              })}
            </div>
          );
        })}
      <div className={`${styles.customColor}`}>
        <div
          className={styles.customTextColor}
          style={{ background: customColor, color: customColor }} onClick={() => changeColorVal(customColor)}>
          
        </div>
        <div style={{ width: '70%' }}>
          <input
            type="text"
            className={`${styles.textColorInput} ${disableTextSelect ? styles.disabled: ''}`}
            value={customColorText}
            onChange={(e) => changeValue(e)}
            onBlur={(e) => callBlurEvent(e)}
            onFocus={(e) => setIsTextActive(true)}
          />
        </div>
      </div>
      {!disableTextSelect && <div className={styles.customCardActive}></div>}
      {disableTextSelect && <div className={styles.cardUnActive}></div>}
    </div>
  );
};
